export default __webpack_public_path__ + "static/media/2005.c1a5b0fc.png";